import feFunctions from '../../services/fe-functions';

export default class FormBuilderService {
  constructor(firebase, RenderService, FEService) {
    'ngInject';
    this.firebase = firebase;
    this.rs = RenderService;
    this.fe = FEService;
  }
  
  async exportTemplate(template, update = false) {
    var functionsURL = this.fe.getRequestFuncsUrl();
    
    var templateObject = {
      templateId: template.$id,
      templateName: template.title,
      functionsURL,
      update
    }
    
    // Tempate object: 
    // { templateId, templateName, references: { referenceId { tableId, tableName, parents: { parentReferenceId: childParentReferenceField } } }}
    templateObject.references = template.references
      .filter(ref => ref.templateId === template.id)
      .reduce((acc, ref) => { 
        acc[ref.id] = {
          tableId: ref.tableId, 
          tableName: ref.name,
          tableAlias: ref.name,
          parents: 
          template.relations.filter(rel => rel.childId === ref.id)
            .reduce((acr, rel) => { acr[rel.parentId] = rel.fieldId; return acr; }, {})
        }; 
        return acc; 
      }, {});
    
    const exportTemplate = feFunctions(this.firebase).httpsCallable('exportTemplate');
    return exportTemplate({ template: templateObject });
  }
}
  